import { Component } from '@angular/core';

@Component({
  selector: 'app-content-area',
  templateUrl: './content-area.component.html',
  standalone: false,
  host: {
    'class': 'lg:col-span-8 dark:bg-black sm:dark:border-[#404040] sm:dark:border sm:dark:border-l-0 h-full overflow-x-scroll dark:text-white sm:p-6 p-0 rounded-r'
  }

})
export class ContentAreaComponent {
}
